import { render, staticRenderFns } from "./AddPrenatal.vue?vue&type=template&id=dbd9c146&scoped=true"
import script from "./AddPrenatal.vue?vue&type=script&lang=js"
export * from "./AddPrenatal.vue?vue&type=script&lang=js"
import style0 from "./AddPrenatal.vue?vue&type=style&index=0&id=dbd9c146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd9c146",
  null
  
)

export default component.exports